import React, { FunctionComponent } from 'react';

import { i18n } from '../../../../../../../helpers/i18n';
import { Island } from '../../../island';
import { UnsupportedBrowserStub } from '../../../unsupported-browser-stub';
import { VideoControls } from '../video-controls';
import css from './styles.css';

export const VideoStub: FunctionComponent = () => {
    return (
        <div className={css.container}>
            <UnsupportedBrowserStub
                className={css.stubWrapper}
                title={i18n('settings-v2', 'video-change-not-supported-title')}
            />
            <Island className={css.controls}>
                <VideoControls />
            </Island>
        </div>
    );
};
